<ng-container *transloco="let t">
  <div class="admin-card mb-3">
    <app-admin-actions-header (onExportToPdf)="onGetFileFromServer('pdf')"
                              (onExportToXls)="onGetFileFromServer('xlsx')">
      <div slot="leadingWidgets">
        <app-rounded-button [label]="t('race.management.competitors.register')" (onClick)="onRegisterToRace()"
                            [isDisabled]="disableRegisterToRace" [btnClass]="'rounded-button--solid'"><i
          class="bi bi-plus-circle pe-2"></i>
        </app-rounded-button>
      </div>
      <div slot="trailingWidgets">
      </div>
    </app-admin-actions-header>
    @if (eventItem?.racesList?.length ?? 0 > 0;) {
      <div class="table-responsive d-xl-block d-none">
        <app-sortable-table cssClass="table dark-header table-last-row-no-border" [items]="eventItem!.racesList">
          <thead class="table-header">
          <tr>
            <th scope="col" [sortBy]="['id']" class="id-column-width">{{ t('event.item.id') }}</th>
            <th scope="col" [sortBy]="['firstname', 'lastname']">{{ t('app.common.item.name') }}
            </th>
            <th scope="col" [sortBy]="['raceStart']" class="date-column-width">{{ t('event.item.date') }}
            </th>
            <th scope="col" [sortBy]="['competitorCount?.total']" class="competitor-count-column">
              {{ t('event.item.competitor.count') }}
            </th>
            <th scope="col" [sortBy]="['status']" class="status-column-width">{{ t('event.item.status') }}
            </th>
          </tr>
          </thead>
          <tr app-table-header-separator></tr>
          <tbody>
            @for (race of eventItem?.racesList;track race) {
              <tr>
                <td class="center-align">
                  <div class="td-min-height">{{ race.id }}</div>
                </td>
                <td class="center-align name-col cursor-pointer">
                  <a class="text-black fw-semibold" (click)="goToRaceManagement(race)">
                    <app-language-output [hrLabel]="race.name" [enLabel]="race.nameEng" [itLabel]="race.nameIta"
                                         [siLabel]="race.nameSlo" [defaultLanguage]="eventItem?.defaultLanguage"
                                         [languages]="languages"/>
                  </a>
                </td>
                <td class="center-align">
                  {{ race.raceStart | localizedDate:'short' }}
                </td>
                <td class="center-align">{{ race.competitorCount?.total }}</td>
                <td class="center-align">
                  <div class="status-badge" [ngClass]="{'accepted': race.status === 1 , 'publishing': race.status === 2, 'denied': race.status
                         === 0 || race.status===4 || race.status===8 ,'on-hold': race.status === 5, 'blue':
                         race.status === 3}">
                      <span class="fw-bold">
                        {{ t("race.status." + race.status) | uppercase }}
                      </span>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </app-sortable-table>
      </div>
    } @else {
      <app-empty-state-admin/>
    }

    <!--      Mobile table-->
    @for (race of eventItem?.racesList;let isLast = $last;track race) {
      <div class="d-block d-xl-none" (click)="goToRaceManagement(race)">
        <div class="d-flex justify-content-end align-items-center mobile-table-row" [class.isLastRow]="isLast">
          <div class="flex-grow-1">
            <div class="d-flex flex-column" [class.isLastRow]="isLast">
              <div>
                {{ t('event.item.id') }}: {{ race.id }}
              </div>
              <div>
                {{ t('app.common.item.name') }}:
                <app-language-output [hrLabel]="race.name" [enLabel]="race.nameEng" [itLabel]="race.nameIta"
                                     [siLabel]="race.nameSlo" [defaultLanguage]="eventItem?.defaultLanguage"
                                     [languages]="languages"/>
              </div>
              <div>
                {{ t('event.item.date') }}: {{ race.raceStart | localizedDate:'short' }}
              </div>

              <div>
                {{ t('event.item.competitor.count') }}: {{ race.competitorCount?.total }}
              </div>
              <div>
                {{ t('app.common.status') | titlecase }}: {{ t("race.status." + race.status) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</ng-container>
